#import "../fragments/drip-sequence-stub-fragment.graphql"

mutation UpdateDripSequence($dripSequence: CampaignUpdateInput!) {
    campaignUpdate(input: $dripSequence) {
        campaign {
            ...DripSequenceStubFragment
        }
    }
}
